<template lang="pug">
#mb.tab-pane.fade.show.active
  template(v-if="getBankList || getEwallet")
    .mb-2
      .row.bank-select-wrap.mx-0
        label.col-6.bank-wrap.py-2.button-radio(v-if="getEwallet" :class="[{'selected-option' : method === 'ewallet'}]")
          input(type="radio" name="radio" value="ewallet" v-model="method")
          i.fa-solid.fa-wallet 
          span &nbsp;{{$t('ui.bank_ewallet')}}
          .checked-selected(v-if="method==='ewallet'")
            i.fa-solid.fa-check
        label.col-6.bank-wrap.py-2.button-radio(v-if="getBankList" :class="[{'selected-option' : method === 'bank'}]")
          input(type="radio" name="radio" value="bank" v-model="method")
          i.fas.fa-landmark
          span &nbsp;{{$t('ui.bank')}}
          .checked-selected(v-if="method==='bank'")
            i.fa-solid.fa-check
    ewalletDetails(v-if="method==='ewallet' && getEwallet")
    bankDetails(v-if="method==='bank' && getBankList")
    //- ewalletDetails(v-if="method==='ewallet' && getEwallet" :activeList="eActivelist")
    //- bankDetails(v-if="method==='bank' && getBankList" :activeList="bActivelist")
  template(v-else)
    .mb-2.text-center {{$t('ui.bankdetail_reminder')}}
    .mb-2.text-center
      a.btn-sub.err-btn.router-link-active(href="javascript:void(0)" @click="switchTab") {{$t('ui.bankdetail_reminder1')}}
  
</template>
<script>
import ewalletDetails from '@/component/bank/_ewalletDetails.vue'
import bankDetails from '@/component/bank/_bankDetails.vue'
export default {
  components:{
    ewalletDetails,
    bankDetails
  },
  data(){
    return{
      method: "ewallet",
      // eActivelist: [],
      // bActivelist: [],
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getBankList() {
      return this.$store.getters.transaction
    },
    getEwallet(){
      return this.$store.getters.transactionEwallet
    }
  },
  created(){
    if(!this.getEwallet){
      this.method = "bank"
    }
    // this.getActiveList()
  },
  methods:{
    switchTab(){
      this.$emit("switchTab", 3)
    },
    // getActiveList(){
    //   if (this.sessionToken) {
    //     let account_id = this.accountID
    //     let auth_token = this.sessionToken
    //     this.$store
    //       .dispatch("user/activeList", { account_id, auth_token })
    //       .then(response => {
    //         if (response.success == true) {
		// 					response.data.forEach(y => {
    //             if(y.category==='BANK'){
    //               this.bActivelist.push(y)
    //             }else if(y.category === 'EWALLET'){
    //               this.eActivelist.push(y)
    //             }
                
    //           })
    //         } else {
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }    
    //         }
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.button-radio {
  display: inline-block;
  // background-color: #007bff;
  color: #fff;
  // border: 1px solid #7a18a5;
  padding: 10px 20px;
  margin: 5px 0;
  cursor: pointer;
}

.button-radio input {
  display: none; /* Hide the actual radio inputs */
}

.button-radio input:checked + label {
  background-color: #fff;
  color: #007bff;
}

.button-radio input:focus + label {
  outline: 2px solid #007bff;
}
.selected-option{
  // background: #7a18a5;
  border: 1px solid #7a18a5;
}
.checked-selected{
  position: absolute;
  top: 0;
  right: 0;
  background: #7a1805;
  width: 20px;
}
</style>